// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import Sukeos from 'sukeos-ui'
import 'sukeos-ui/styles/index.css'
import '@/assets/css/index.css'
import '@/permission'

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false
// Vue.config.silent = true
// Vue.config.devtools = false

Vue.use(Sukeos)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

Vue.filter('dateDay', value => {
  if (!value) {
    return ''
  }
  const data = parseInt(value)
  const year = new Date(data).getFullYear()
  const month = new Date(data).getMonth() + 1
  const day = new Date(data).getDate()
  return year + '.' + addZero(month) + '.' + addZero(day)
})
Vue.filter('dateMonth', value => {
  if (!value) {
    return ''
  }
  const data = parseInt(value)
  const year = new Date(data).getFullYear()
  const month = new Date(data).getMonth() + 1
  return year + '.' + addZero(month)
})
Vue.filter('dateTime', value => {
  if (!value) {
    return ''
  }
  const data = parseInt(value)
  const year = new Date(data).getFullYear()
  const month = new Date(data).getMonth() + 1
  const day = new Date(data).getDate()
  const hours = new Date(parseInt(data)).getHours()
  const minutes = new Date(parseInt(data)).getMinutes()
  const seconds = new Date(parseInt(data)).getSeconds()
  return year + '.' + addZero(month) + '.' + addZero(day) + ' ' + addZero(hours) + ':' + addZero(minutes) + ':' + addZero(seconds)
})
Vue.filter('time', value => {
  if (!value) {
    return ''
  }
  const data = parseInt(value)
  const hours = new Date(parseInt(data)).getHours()
  const minutes = new Date(parseInt(data)).getMinutes()
  const seconds = new Date(parseInt(data)).getSeconds()
  return addZero(hours) + ':' + addZero(minutes) + ':' + addZero(seconds)
})

function addZero (value) {
  return value < 10 ? '0' + value : value
}



// WEBPACK FOOTER //
// ./src/main.js